export default "__VITE_ASSET__1bc81cb5__"